'use client';

import { cn } from '@/app/lib/utils';
import { Picture, Typography, LinkWrapper } from '@workspace/ui/common';
import { IProductItem } from './interfaces';

interface ProductItemProps {
  product: IProductItem;
  className?: string;
  text?: string;
}

export function ProductItem({ product, className = '', text = 'View detail' }: ProductItemProps) {
  const { name, image, viewDetailLink } = product;
  const imageAlt = image?.bynderImage?.alt || image?.alt || name;

  return (
    <LinkWrapper link={viewDetailLink}>
      <div className={cn('flex flex-col bg-white overflow-hidden w-full ', className)}>
        {/* Product Image */}
        <div className="relative bg-secondary-100 overflow-hidden aspect-square w-full">
          {image?.asset?.url && (
            <Picture
              image={image}
              src={image.asset.url}
              alt={imageAlt}
              desktopWidth={285}
              desktopHeight={285}
              mobileWidth={156}
              mobileHeight={156}
              fill
              imgClassName="object-cover transition-transform duration-300 ease-in-out hover:scale-110 cursor-pointer"
            />
          )}
        </div>

        {/* Product Content */}
        <div className="flex flex-col gap-2 md:gap-4 items-start mt-2">
          {/* Product Name */}
          <Typography
            as="h3"
            variant="h6"
            className="text-secondary-400 leading-6.5 text-sm line-clamp-2 cursor-pointer"
            title={name}
          >
            {name}
          </Typography>

          {/* View Detail Button */}
          {viewDetailLink && (
            <Typography variant="bodyMd" className="text-primary font-semibold leading-tight font-heading line-clamp-1">
              {text}
            </Typography>
          )}
        </div>
      </div>
    </LinkWrapper>
  );
}
